export default function() {
  const loader = document.getElementById('loader');
  const formTriggers = document.querySelectorAll('.loading-trigger');

  for (const el of formTriggers) {
    el.addEventListener('submit', () => loader.classList.add('open'));
  }
}
